import type { SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = (isCreate) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: isCreate ? 'flex-end' : 'center',
  gap: (p) => p.spacing(0.5),
});
